import { connect } from 'react-redux';
import Summary from './ShippingAddressSummary';

const mapStateToProps = ({ wallet }) => ({
  address: wallet.status?.shipping_address,
  firstName: wallet.status?.name?.first_name,
  lastName: wallet.status?.name?.last_name,
});

const ShippingAddressSummary = connect(mapStateToProps)(Summary);
export default ShippingAddressSummary;
